<!--<app-sidebar (changeSidebarStatus)="sidebarOpen = !sidebarOpen"></app-sidebar>-->
<div class="main bg-themeGrey-100 pb-sm h-full" [class.eventFullscreen]="eventService.isFullScreen$ | async">
  <app-header></app-header>
  <div class="container-fluid">
    <div >
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</div>

<!--<app-modal></app-modal>-->
